import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { emailPost as emailPostAction, getServicePlans as getServicePlansAction, setPlansForAsset as setPlansForAssetAction, getPlansForAsset as getPlansForAssetAction, getServicePostMailingList as getServicePostMailingListAction, updatePost as updatePostAction } from '../../state/actions';
import { PublishPostDropdown } from './PublishPostDropDown';
import { jsx as _jsx } from "react/jsx-runtime";

var PublishPostDropdownContainer = function PublishPostDropdownContainer(_ref) {
  var post = _ref.post,
      loading = _ref.loading,
      getServicePlans = _ref.getServicePlans,
      servicePlans = _ref.servicePlans,
      resources = _ref.resources,
      providerSelectedService = _ref.providerSelectedService,
      serviceId = _ref.serviceId,
      isOpen = _ref.isOpen,
      getServicePostMailingList = _ref.getServicePostMailingList,
      servicePostMailingList = _ref.servicePostMailingList,
      setShowPublished = _ref.setShowPublished,
      setPlansForAsset = _ref.setPlansForAsset,
      emailPost = _ref.emailPost,
      provider = _ref.provider,
      setIsPublished = _ref.setIsPublished,
      getPlansForAsset = _ref.getPlansForAsset;
  var serviceName = providerSelectedService === null || providerSelectedService === void 0 ? void 0 : providerSelectedService.name; // Get/refresh plans

  useEffect(function () {
    if (!isOpen) return;
    if (serviceId) getServicePlans(serviceId);
  }, [isOpen, providerSelectedService]);
  useEffect(function () {
    if (isOpen && serviceId && post) getServicePostMailingList(serviceId, post.id);
  }, [isOpen, serviceId, post]);
  return /*#__PURE__*/_jsx(PublishPostDropdown, {
    post: post,
    loading: loading,
    servicePlans: servicePlans,
    resources: resources,
    setShowPublished: setShowPublished,
    servicePostMailingList: servicePostMailingList,
    setPlansForAsset: setPlansForAsset,
    serviceId: serviceId,
    setIsPublished: setIsPublished,
    emailPost: emailPost,
    provider: provider,
    providerSelectedService: providerSelectedService,
    serviceName: serviceName,
    getPlansForAsset: getPlansForAsset
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users$cur;

  return {
    provider: (_state$auth$users$cur = state.auth.users.current) === null || _state$auth$users$cur === void 0 ? void 0 : _state$auth$users$cur.provider,
    providerSelectedService: state.provider.providerServices[state.provider.providerSelectedServiceId],
    servicePlans: Object.values(state.provider.plans).filter(function (p) {
      return p.active;
    }),
    resources: state.assets.resources,
    servicePostMailingList: state.provider.servicePostMailingList
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    emailPost: function emailPost(serviceId, postId, target, planIds) {
      return dispatch(emailPostAction(serviceId, postId, target, planIds));
    },
    getServicePlans: function getServicePlans(serviceId) {
      return dispatch(getServicePlansAction(serviceId));
    },
    setPlansForAsset: function setPlansForAsset(payload) {
      return dispatch(setPlansForAssetAction(payload));
    },
    getPlansForAsset: function getPlansForAsset(payload) {
      return dispatch(getPlansForAssetAction(payload));
    },
    getServicePostMailingList: function getServicePostMailingList(serviceId, postId) {
      return dispatch(getServicePostMailingListAction(serviceId, postId));
    },
    updatePost: function updatePost(serviceId, postId, post) {
      return dispatch(updatePostAction(serviceId, postId, post));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishPostDropdownContainer);